module.exports = __webpack_public_path__ + "images/Carousel_Placeholder.png";